import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export async function logarAdmin(email: string, password: string) {
  const response = await axios.post(
    `${API_URL}/admin/login`,
    { email, password },
  );

  console.log(response.status);
  return response.data;
}

export default logarAdmin;
